<template>
    <div class="page">
        <div class="main">
            <div class="coupon-top">
                <img :src="rewardPointInfo.imgUrl">
                <el-row type="flex" justify="center" class="button-line">
                    <el-button type="info" v-if="rewardPointInfo.isAppUse" @click="openShowDialog" round>我要兌換</el-button>
                    <el-button type="primary" v-if="rewardPointInfo.giftLimitType !== 1" class="donate-btn" @click="goTransferBonusPoints">
                        <img src="@/assets/images/icon-card-trans.svg">轉贈
                    </el-button>
                </el-row>
            </div>
            <div class="container">
                <div class="bonus-points-record-block">
                    <div class="total-point">
                        <span class="red no">{{$public.numberFormat(rewardPointInfo.rewardPointUserPoint)}}</span><span class="red">點 / </span>可折抵金額<span class="red">${{$public.numberFormat(rewardPointInfo.discount)}}</span>
                    </div>
                    <div class="invalid" v-if="rewardPointInfo.expiringPoint > 0">
                        <img src="../../../assets/images/clock_red.svg">
                        即將失效 {{$public.numberFormat(rewardPointInfo.expiringPoint)}} 點
                    </div>
                </div>
                <div>
                    <h6 class="mt-3">活動說明</h6>
                    <p>{{rewardPointInfo.content}}</p>
                </div>
                <div>
                    <h6 class="mt-4">注意事項</h6>
                    <p v-html="rewardPointInfo.contentPrecautions"></p>
                </div>
            </div>
        </div>
        <CommDialog :value="isShowDialog"
                    :icon="icons"
                    :outerContent="'確定使用點數'"
                    :append-to-body="true"
                    :mainContent="mainContent"
                    :isTextBox="isTextBox"
                    :type="'tel'"
                    :isClearText = "true"
                    @result="onDialogResult">
          <div class="red small mt-3 text-center">注意！使用的點數無法取消<br>送出前請向使用單位再次確認</div>
        </CommDialog>

        <!--todo 直接兌換回饋-->
        <CommDialog :value="showFeedbackDialog"
                    :icon="icons"
                    :isShowTime="isShowTimes"
                    :outerContent="mainFeedbackContent"
                    :append-to-body="true"
                    :isCancel="false"
                    @result="onFeedbackDialogResult"/>

        <!--todo 掃碼兌換-->
        <CommDialog :value="isShowQrcodeDialog"
                    :outerContent="qrcodeOuterContent"
                    :mainContent="qrcodeMainContent"
                    :isCancel="false"
                    :positiveLabel="'關閉'"
                    :isIcon="false"
                    :isQrcode="true"
                    :qrcodeSrc="qrcodeSrc"
                    :append-to-body="true"
                    @result="isShowQrcodeDialog = false"
        >
          <slot>
            <el-button v-if="rewardPointInfo.appUseType === 2 && rewardPointInfo.useTypeList.indexOf('1') !== -1 && !isWeb" @click="onClickCamera" circle class="mt-3">
              <img src="@/assets/images/camera.svg" alt="相機" class="m-0" style="width: 30px">
            </el-button>
          </slot>
        </CommDialog>

        <!--todo 掃碼兌換回饋-->
        <CommDialog :value="isShowCheckDialog"
                    :outerContent="checkOuterContent"
                    :eventType="checkDialogEvent"
                    :isCancel="isCheckCancel"
                    :icon="icons"
                    :isShowTime="isShowTimes"
                    :positiveLabel="checkPositiveLabel"
                    :append-to-body="true"
                    @result="onCheckDialogResult"/>

        <!--網頁轉贈用-->
        <CommDialog :value="isShowDialogWeb"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <TransferBonusPoints isWeb :dataTokenWeb="dataTokenWeb" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb"/>
        </CommDialog>
    </div>
</template>

<script>

    import CommDialog from '@/components/CommDialog'
    import TransferBonusPoints from "@/views/gift/TransferBonusPoints";
    import * as mutationTypes from "@/store/mutationTypes";

    const scanQRCodeUse = 1;
    const openScan = 2;

    export default {
        name: "BonusPointsDetail",
        components:{
            CommDialog,
            TransferBonusPoints,
        },
        props: {
            rewardPointInfo: {
                default() {
                    return {}
                }
            },
            isWeb: Boolean,
        },
        data() {
            return {
                /****我要使用彈窗****/
                isShowDialog: false,
                mainContent: '', //次標
                isTextBox: true,                  //輸入字數欄位
                doubleCheck : false,              //再次確認

                /****本次使用彈窗****/
                showFeedbackDialog: false,
                mainFeedbackContent: '',         //次標

                /****Qrcode彈窗****/
                isShowQrcodeDialog: false,
                qrcodeSrc: '',
                qrcodeOuterContent: '',
                qrcodeMainContent: '',

                /****確認彈窗****/
                isShowCheckDialog: false,
                checkOuterContent: '',
                checkDialogEvent: 0,
                isCheckCancel: false,
                checkPositiveLabel : '',
                icons: require('@/assets/images/dialog_ticket.svg'),
                isShowTimes: false,
                isSuccess: false,
                checkUseTimer: null,
                checkUseTimerCount: 0,

                usePoint: 0,
                delayRun: null,

                dataTokenWeb: '',
                isShowDialogWeb: false,

            }
        },
        mounted() {
          this.delayRun = setTimeout(() => {
            let rewardPointInfo = this.rewardPointInfo;
            if(rewardPointInfo.scanParamData.usePoint > 0) {
              this.usePoint = rewardPointInfo.scanParamData.usePoint

              if(rewardPointInfo.isCanUseObject) {
                this.checkDialogEvent = scanQRCodeUse
                this.checkOuterContent = `確定使用點數<div class="text-left small mt-2"><i class="el-icon-discount"></i> ${rewardPointInfo.useObjectName}<br><i class="el-icon-present"></i> ${rewardPointInfo.name} <b class="red">${rewardPointInfo.scanParamData.usePoint}</b> 點</div>`
                this.checkPositiveLabel = "確定"
                this.icons = require('@/assets/images/dialog_ticket.svg')
              } else {
                this.checkDialogEvent = openScan
                this.checkOuterContent = `本紅利點數不適用於此店家<br>請確認店家QR碼是否正確`
                this.checkPositiveLabel = "再掃一次"
                this.icons = require('@/assets/images/dialog_question.svg')
              }
              this.isCheckCancel = true;
              this.isShowCheckDialog = true;
            }
          }, 100) ;
        },
        beforeDestroy() {
            //清除延遲執行
            clearTimeout(this.delayRun);
            clearInterval(this.checkUseTimer);
        },
        methods: {
          goTransferBonusPoints() {
            let dataToken = this.$crypto.objectToURIComponent({
              "usedType":  "TransferBonusPoints",
              "id":        this.rewardPointInfo.id,
            })

              if(!this.isWeb){
                  this.$router.push({name: 'TransferBonusPoints', query: {dataToken: dataToken}})
              }else {
                  //單店網頁版用
                  this.dataTokenWeb = {dataToken: dataToken}
                  this.isShowDialogWeb = true
              }
          },
          //使用點數
          onDialogResult(isSure, _, text) {
            if (isSure && !this.doubleCheck) {
              if(isNaN(parseInt(text)) || parseInt(text) <= 0 || (parseInt(text) > this.rewardPointInfo.rewardPointUserPoint)) {
                this.$public.showNotify("請確認點數數量", false);
              } else {
                this.usePoint = parseInt(text)

                switch (this.rewardPointInfo.appUseType) {
                  case 1:
                    this.doubleCheck = true
                    this.mainContent = `<h4 class="mt-2">本次使用${this.rewardPointInfo.name} <b class="red">${this.$public.numberFormat(this.usePoint)}</b> 點</h4>`
                    this.isTextBox = false
                    this.icons = require('@/assets/images/dialog_ticket.svg')
                    break;
                  case 2:
                    this.defaultShowDialog();
                    this.getRewardPointToken();
                    break;
                  case 4:
                    this.onClickCamera();
                    break;
                }
              }
            } else if(isSure && this.doubleCheck) {
              this.directlyUseRewardPoint();
            } else {
              this.defaultShowDialog();
            }
          },
          //本次使用
          onFeedbackDialogResult() {
              this.showFeedbackDialog = false
              this.defaultShowDialog()
              if (this.isWeb && this.isSuccess) {
                  window.location.reload();
              }
          },
          defaultShowDialog() {
            this.isShowDialog = false;
            this.isTextBox = true
            this.icons = require('@/assets/images/dialog_ticket.svg')
            this.mainContent = '<div class="mt-2">請輸入要使用的點數數量</div>'
            this.doubleCheck = false
          },
            openShowDialog(){
                this.isShowDialog = true;
                this.icons = require('@/assets/images/dialog_ticket.svg')
                this.mainContent = '<div class="mt-2">請輸入要使用的點數數量</div>'
            },
            directlyUseRewardPoint: function () {
                this.isLoading = true;
                this.isSuccess = false;

                this.$http.fetchWithAuthEncrypt`DirectlyUseRewardPoint${{
                    id: this.rewardPointInfo.id,
                    usePoint: this.usePoint,
                }}
                ${json => {
                    this.isShowDialog = false;

                    if (json.status) {
                        this.isShowTimes = true
                        this.isSuccess = true
                        this.icons = require('@/assets/images/dialog_complete.gif')
                        this.mainFeedbackContent = '兌換成功<h4 class="mt-2"><i class="el-icon-present"></i> ' + `${this.rewardPointInfo.name} <b class="red">${this.$public.numberFormat(this.usePoint)}</b> 點</h4>`
                        this.$emit("triggerEvent", {
                            "event": "setupData",
                        })
                    } else {
                        this.isShowTimes = false
                        this.icons = require('@/assets/images/dialog_question.svg')
                        this.mainFeedbackContent = '兌換失敗<br>' + json.message;
                    }
                    this.showFeedbackDialog = true;
                    this.isLoading = false;
                }}`;
            },
            getRewardPointToken() {
                this.$http.fetchWithAuthEncrypt`GetRewardPointToken${{
                    id: this.rewardPointInfo.id,
                    usePoint: this.usePoint,
                }}
                ${json => {
                    if (json.status) {
                        this.qrcodeSrc = json.data;
                        this.qrcodeOuterContent = `${this.rewardPointInfo.name}QRCode`;
                        this.qrcodeMainContent = `${this.usePoint}點`;
                    } else {
                        this.qrcodeSrc = '';
                        this.qrcodeOuterContent = json.message;
                        this.qrcodeMainContent = '';
                    }

                    this.isShowQrcodeDialog = true;
                }}`;
            },
            scanQRCodeUseRewardPoint() {
                this.isLoading = true;
                this.$http.fetchWithAuthEncrypt`ScanQRCodeUseRewardPoint${{
                    id: this.rewardPointInfo.id,
                    usePoint: this.usePoint,
                    useObject: this.rewardPointInfo.scanParamData.type,
                    useObjectId: this.rewardPointInfo.scanParamData.id,
                }}
                 ${json => {
                    if (json.status) {
                        this.isShowTimes = true
                        this.checkOuterContent = '兌換成功<h4 class="green mb-2 mt-2">' + this.rewardPointInfo.useObjectName + '</h4> <h4><i class="el-icon-present"></i> ' + this.rewardPointInfo.name + '<b class="red"> ' + this.rewardPointInfo.scanParamData.usePoint + ' </b> 點</h4>';
                        this.icons = require('@/assets/images/dialog_complete.gif')
                        this.$emit("triggerEvent", {
                            "event": "setupData",
                        })
                    } else {
                        this.isShowTimes = false
                        this.checkOuterContent = '兌換失敗<br>' + json.message;
                        this.icons = require('@/assets/images/dialog_question.svg')
                    }

                    this.checkPositiveLabel = "關閉"
                    this.checkDialogEvent = 0;
                    this.isCheckCancel = false;
                    this.isShowCheckDialog = true;
                    this.isLoading = false;
                }}`;
            },
          onClickCamera() {
            sessionStorage.setItem('scanQRCodeUseRewardPointUsePoint', this.usePoint);
            this.$router.push({ name: `ScanCode` });
          },
          onCheckDialogResult(isSure, event) {
            this.isShowCheckDialog = false;

            if(isSure) {
              if(event === scanQRCodeUse) {
                this.scanQRCodeUseRewardPoint();
              } else if (event === openScan) {
                this.onClickCamera();
              }
            }
          },
            onCommDialogClose(result) {
                this.isShowDialogWeb = false;
                if(result){
                    //有轉贈成功時頁面刷新
                    window.location.reload();
                }
            },
            checkUseRewardPoint(time) {
                let self = this;
                self.$http.fetchWithAuthEncrypt`CheckUseRewardPoint${{
                    id: self.rewardPointInfo.id,
                    time: time,
                }}${json => {
                    if (json.status) {
                        clearInterval(this.checkUseTimer);
                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: '兌換成功',
                            icons: require('@/assets/images/dialog_complete.gif'),
                            isResultEvent: true,
                            eventName: "isContinue",
                        });
                    }
                }}}`;
            },
        },
        watch: {
            '$store.state.publicCommDialogData.isShowDialog': function() {
                let routerName = this.$route.name
                if (routerName === 'BonusPointsPage' || (routerName === 'WebStoreRewardPoint' && this.isWeb)) {
                    this.isShowQrcodeDialog = false;
                    if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                        if (this.$store.state.publicCommDialogData.eventName === "isContinue") {
                            this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                isResultEvent: false,
                                eventName: "",
                            });

                            this.$emit("triggerEvent", {
                                "event": "setupData",
                            })

                            if (this.isWeb) {
                                window.location.reload();
                            }
                        }
                    }
                }
            },
            isShowQrcodeDialog() {
                if (this.isWeb) {
                    clearInterval(this.checkUseTimer);
                    if (this.isShowQrcodeDialog) {
                        let time = this.$public.dateFormat('yyyy-MM-dd hh:mm:ss')
                        this.checkUseTimerCount = 0
                        this.checkUseTimer = setInterval(() => {
                            this.checkUseTimerCount++
                            if (this.checkUseTimerCount > 60) {
                                clearInterval(this.checkUseTimer);
                                this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                    isShowDialog: true,
                                    outerContent: '逾時，請重新操作',
                                });
                            } else {
                                this.checkUseRewardPoint(time)
                            }
                        }, 3000)
                    }
                }
            },
        },
    }
</script>
<style lang="less" scoped>
    .main{
        @media(min-width: 1024px){
            margin-top: 20px;
        }
    }
    .bonus-points-record-block{
        border-bottom: 1px solid var(--color-gray);
        text-align: center;
        .total-point{
            font-size: 14px;
            margin: 20px 0 10px;
            @media(min-width: 1024px){
                margin-top: 5px;
            }
            .no{
                font-size: 28px;
                font-weight: 800;
            }
            span{
                margin-left: 5px;
            }
        }
        .invalid{
            margin: 0 0 5px;
            font-size: 12px;
            img{
                width: 20px;
                vertical-align: -25%;
            }
            @media(min-width: 1024px){
                font-size: 14px;
            }
        }

    }
</style>